import {
  YPartyKitProvider
} from "./chunk-5XRLZYHC.mjs";
import "./chunk-7S3AP2K5.mjs";

// src/react.ts
import { useState, useEffect } from "react";
function useYProvider(yProviderOptions) {
  const { host, room, party, doc, options } = yProviderOptions;
  const [provider] = useState(
    () => new YPartyKitProvider(host, room, doc, {
      connect: false,
      party,
      ...options
    })
  );
  useEffect(() => {
    provider.connect();
    return () => provider.disconnect();
  }, [provider]);
  return provider;
}
export {
  useYProvider as default
};
